module.exports = __webpack_public_path__ + "img/1679985177228-16799851606372350312257437422814.jpg.d84aeec1.webp";